export const INVALID_PAYLOAD = "INVALID_PAYLOAD";

export const AUTH_CURRENT_REQ = "@AUTH/AUTH_CURRENT_REQ";
export const AUTH_CURRENT_SUCCESS = "@AUTH/AUTH_CURRENT_SUCCESS";
export const AUTH_CURRENT_FAIL = "@AUTH/AUTH_CURRENT_FAIL";

export const AUTH_LOGIN_GOOGLE_REQ = "@AUTH/AUTH_LOGIN_GOOGLE_REQ";
export const AUTH_LOGIN_GOOGLE_SUCCESS = "@AUTH/AUTH_LOGIN_GOOGLE_SUCCESS";
export const AUTH_LOGIN_GOOGLE_FAIL = "@AUTH/AUTH_LOGIN_GOOGLE_FAIL";

export const AUTH_LOGOUT_GOOGLE_REQ = "@AUTH/AUTH_LOGOUT_GOOGLE_REQ";
export const AUTH_LOGOUT_GOOGLE_SUCCESS = "@AUTH/AUTH_LOGOUT_GOOGLE_SUCCESS";
export const AUTH_LOGOUT_GOOGLE_FAIL = "@AUTH/AUTH_LOGOUT_GOOGLE_FAIL";
